"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var react_redux_1 = require("react-redux");
var TopBar_1 = __importDefault(require("../TopBar"));
var PostMedia_1 = require("../PostMedia");
var LastUpdatedDate_1 = __importDefault(require("../LastUpdatedDate"));
var PublicCode_1 = __importDefault(require("../../PublicCode"));
var DeveloperName_1 = __importDefault(require("../DeveloperPostContent/DeveloperName"));
var GeneralSettings_1 = require("../../../constants/GeneralSettings");
var Price_1 = __importDefault(require("../../Price"));
var DailyMonthlyPrice_1 = __importDefault(require("../../DailyMonthlyPrice"));
var PriceDescription_1 = __importDefault(require("../../Price/PriceDescription"));
var MonthlyMortgage_1 = __importDefault(require("../../MonthlyMortgage"));
var globalSlice_1 = require("../../../features/global/globalSlice");
var CalculatorIcon_1 = __importDefault(require("../../Icons/CalculatorIcon"));
var ColorCodes_1 = require("../../../constants/ColorCodes");
var MortgageButton_1 = __importDefault(require("../../MortgageButton"));
var PostMainInfo_1 = __importDefault(require("../PostMainInfo"));
var PersonalPostContent_1 = __importDefault(require("../PersonalPostContent"));
var DeveloperPostContent_1 = __importDefault(require("../DeveloperPostContent"));
var AppFooter_1 = __importDefault(require("../../AppFooter/AppFooter"));
var PostViewContentTypes_1 = require("../../../constants/PostViewContentTypes");
var GeneralSettings_2 = require("../../../constants/GeneralSettings");
var postSlice_1 = require("../../../features/post/postSlice");
var usePrevious_1 = require("../../../hooks/usePrevious");
var mediaHelper_1 = require("../../../helpers/mediaHelper");
var ModalContent = function (_a) {
    var fingerprint = _a.fingerprint, isPreview = _a.isPreview, isPostLoading = _a.isPostLoading, setMediaData = _a.setMediaData, setIsRelatedPostClicked = _a.setIsRelatedPostClicked, isRelatedPostClicked = _a.isRelatedPostClicked;
    var t = react_i18next_1.useTranslation('common').t;
    var dispatch = react_redux_1.useDispatch();
    var postData = react_redux_1.useSelector(postSlice_1.selectSinglePost);
    var _b = react_1.useState([]), postMedia = _b[0], setPostMedia = _b[1];
    var _c = react_1.useState(false), isScrolled = _c[0], setIsScrolled = _c[1];
    var _d = react_1.useState(0), scrollTopPosition = _d[0], setScrollTopPosition = _d[1];
    var postDetailsRef = react_1.useRef(null);
    var _e = react_1.useState(PostViewContentTypes_1.SECTION_TYPES.DEVELOPER_INFO), developerCurrentTab = _e[0], setDeveloperCurrentTab = _e[1];
    var _f = react_1.useState(false), isClickedToShowMobileMedia = _f[0], setIsClickedToShowMobileMedia = _f[1];
    var _g = react_1.useState(false), isMortgageButtonClicked = _g[0], setIsMortgageButtonClicked = _g[1];
    var _h = react_1.useState(0), apartmentsTablePositionY = _h[0], setApartmentsTablePositionY = _h[1];
    var previousPostData = usePrevious_1.usePrevious(postData);
    var amdCode = react_1.useMemo(function () {
        return Object.keys(GeneralSettings_1.CURRENCIES).find(function (key) { return GeneralSettings_1.CURRENCIES[key] === 'AMD'; });
    }, [GeneralSettings_1.CURRENCIES]);
    var isDeveloper = react_1.useMemo(function () {
        return postData === null || postData === void 0 ? void 0 : postData.isDeveloper;
    }, [postData]);
    var isRent = react_1.useMemo(function () {
        if (postData) {
            return postData.deal === GeneralSettings_1.DEAL_TYPES.RENT;
        }
    }, [postData]);
    var monthlyMortgageFull = react_1.useMemo(function () {
        if (amdCode && postData) {
            return [
                {
                    monthly_mortgage_amd: postData.monthly_mortgage_amd,
                    currency: amdCode,
                },
            ];
        }
    }, [postData]);
    react_1.useEffect(function () {
        if (postData &&
            developerCurrentTab === PostViewContentTypes_1.SECTION_TYPES.DEVELOPER_INFO &&
            isDeveloper) {
            var postMedia_1 = mediaHelper_1.combineMedia(__assign({}, postData), true);
            postMedia_1 && setPostMedia(postMedia_1);
        }
        if (!isDeveloper && postData && !previousPostData) {
            var postMedia_2 = mediaHelper_1.combineMedia(postData);
            postMedia_2 = __spreadArray(__spreadArray([], postMedia_2), postData.sections.apartment_info[0].media);
            postMedia_2 && setPostMedia(postMedia_2);
        }
    }, [postData, isDeveloper]);
    react_1.useEffect(function () {
        if (isDeveloper &&
            developerCurrentTab !== PostViewContentTypes_1.SECTION_TYPES.APARTMENT_INFO &&
            developerCurrentTab !== PostViewContentTypes_1.SECTION_TYPES.DEVELOPER_INFO &&
            !isClickedToShowMobileMedia) {
            var postMedia_3 = mediaHelper_1.combineMedia(postData);
            postMedia_3 && setPostMedia(postMedia_3);
        }
        developerCurrentTab !== PostViewContentTypes_1.SECTION_TYPES.APARTMENT_INFO &&
            !isMortgageButtonClicked &&
            setIsMortgageButtonClicked(false);
        if (apartmentsTablePositionY &&
            developerCurrentTab === PostViewContentTypes_1.SECTION_TYPES.APARTMENTS_INFO &&
            isMortgageButtonClicked) {
            handleVerticalScroll(apartmentsTablePositionY);
            setIsMortgageButtonClicked(false);
        }
    }, [
        developerCurrentTab,
        apartmentsTablePositionY,
        isMortgageButtonClicked,
    ]);
    react_1.useEffect(function () {
        setMediaData(postMedia);
    }, [postMedia]);
    react_1.useEffect(function () {
        if (postData && fingerprint) {
            dispatch(postSlice_1.addView(fingerprint, String(postData.id)));
        }
    }, [fingerprint]);
    var onScroll = function () { return !isScrolled && setIsScrolled(true); };
    var handleVerticalScroll = function (y) {
        var _a;
        (_a = postDetailsRef.current) === null || _a === void 0 ? void 0 : _a.scroll(0, y);
    };
    var handleScrollToShowMobileMedias = function () {
        handleVerticalScroll(0);
        setIsClickedToShowMobileMedia(true);
    };
    var handleMortgageButtonClick = function () {
        handleSelectTab(PostViewContentTypes_1.SECTION_TYPES.APARTMENTS_INFO);
        setIsMortgageButtonClicked(true);
        dispatch(globalSlice_1.addToastMessage({
            text: t('MORTGAGE_BUTTON.CONSTRUCTOR_ON_CLICK_NOTIFICATION'),
            appearance: 'info',
        }));
    };
    var getTranslation = react_1.useCallback(function (translationKey) {
        return t('POST_PREVIEW.' + translationKey.toUpperCase());
    }, [postData]);
    var handleSelectTab = function (item) {
        setDeveloperCurrentTab(item);
        setIsClickedToShowMobileMedia(false);
    };
    return (react_1.default.createElement("div", { className: "post-details", ref: postDetailsRef, onScroll: function () {
            postDetailsRef.current &&
                !isDeveloper &&
                setScrollTopPosition(postDetailsRef.current.scrollTop);
            !isDeveloper && onScroll();
        } },
        react_1.default.createElement(TopBar_1.default, { isPreview: isPreview, postData: postData, postId: postData.id }),
        react_1.default.createElement(PostMedia_1.PostMedia, { skeleton: isPostLoading, media: postMedia, mobileView: true }),
        react_1.default.createElement("div", { className: "post-content" },
            react_1.default.createElement("div", { className: "post-metadata" },
                react_1.default.createElement("div", { className: "left" },
                    react_1.default.createElement("span", { className: "deal-type deal-" + postData.deal }, getTranslation(postData.deal)),
                    react_1.default.createElement("span", { className: "post-type" }, getTranslation(postData.property_type))),
                postData.publish_date && (react_1.default.createElement("div", { className: "right" },
                    react_1.default.createElement(LastUpdatedDate_1.default, { lastUpdatedDate: postData.updatedToTop
                            ? postData.updatedToTop
                            : postData.publish_date })))),
            react_1.default.createElement(PublicCode_1.default, { code: postData.publicCode, className: "public-code", right: true }),
            postData.title && (react_1.default.createElement("h1", { title: postData.title, className: "post-title" }, postData.title)),
            postData.isDeveloper && (react_1.default.createElement(DeveloperName_1.default, { name: postData.sections.about_building.building_name })),
            react_1.default.createElement("div", { className: "price-section" },
                react_1.default.createElement("span", { className: "price-val" }, postData.deal === GeneralSettings_1.DEAL_TYPES.SELL ? (react_1.default.createElement(Price_1.default, { value: postData.priceFull, className: "price", defaultValue: t('POST_CARD.CONTRACTUAL') })) : (react_1.default.createElement(DailyMonthlyPrice_1.default, { monthlyPrice: postData.priceFull, dailyPriceFull: postData.dailyPriceFull }))),
                react_1.default.createElement("span", { className: "price-description" }, postData.priceFull && postData.priceFull.length ? (react_1.default.createElement(PriceDescription_1.default, { sqmPrice: postData.sqmPrice, deposit: postData.deposit, deal: postData.deal, className: "post-price-description" })) : null)),
            react_1.default.createElement("hr", { className: "horizontal-line" }),
            postData.propertyType !== GeneralSettings_2.PROPERTY_TYPES.COMMERCIAL && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: "mortgage-section" },
                    react_1.default.createElement("div", { className: "mortgage-amount-calc" },
                        !isRent && monthlyMortgageFull && (react_1.default.createElement("div", { className: "monthly-mortgage-val" },
                            react_1.default.createElement(MonthlyMortgage_1.default, { value: monthlyMortgageFull }))),
                        react_1.default.createElement("div", { className: "monthly-mortgage-calc", onClick: function () {
                                dispatch(globalSlice_1.setIsMortgageCalcIconClicked(true));
                            } }, !isRent && (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement("span", { className: "icon-calc" },
                                react_1.default.createElement(CalculatorIcon_1.default, { color: ColorCodes_1.COLOR_CODES.THEME_GREEN })),
                            react_1.default.createElement("span", { className: "calc-mortgage-icon-text" }, t('POST_PREVIEW.MORTGAGE_SECTION.MONTHLY_MORTGAGE')))))),
                    !isRent && (react_1.default.createElement("div", { className: "mortgage-button" },
                        react_1.default.createElement(MortgageButton_1.default, { price: postData.priceFull, region: postData.addressData.state, district: postData.addressData.district, address: postData.addressData.address, isRedirectToCashMe: !postData.isDeveloper, onClick: handleMortgageButtonClick })))),
                react_1.default.createElement("hr", { className: "horizontal-line" }))),
            postData.address && postData.address.length > 0 && (react_1.default.createElement("div", { className: "post-address" },
                react_1.default.createElement("i", { className: "icon-location" }),
                postData.address.map(function (a) { return t(a); }).join(', '))),
            react_1.default.createElement(PostMainInfo_1.default, { postData: postData }),
            !isDeveloper ? (react_1.default.createElement(PersonalPostContent_1.default, { isRent: isRent, postData: postData, isScrolled: isScrolled, scrollTopPosition: scrollTopPosition, handleVerticalScroll: handleVerticalScroll })) : (react_1.default.createElement(DeveloperPostContent_1.default, { currentTab: developerCurrentTab, handleSelectTab: handleSelectTab, postData: postData, setPostMedia: setPostMedia, handleScrollToShowMobileMedias: handleScrollToShowMobileMedias, isMortgageButtonClicked: isMortgageButtonClicked, setIsMortgageButtonClicked: setIsMortgageButtonClicked, setApartmentsTablePositionY: setApartmentsTablePositionY, setIsRelatedPostClicked: setIsRelatedPostClicked, isRelatedPostClicked: isRelatedPostClicked }))),
        react_1.default.createElement(AppFooter_1.default, { layout: "PREVIEW" })));
};
exports.default = ModalContent;
